import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { theme, media } from 'styles';
// Why do you need this? It seems to work without it???
import mixins from 'styles/mixins';
import { Container, Breadcrumbs } from 'components/shared';

const { sp, colors } = theme;

const BannerContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 1;
  height: 100%;
  padding: 40px 15px;
  text-align: center;

  ${media.desktop`
    padding: ${sp.max} 15px;
  `};
`;

const BlogCategoryWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const BlogCategory = styled.div`
  padding: 0 5px;

  a {
    display: inline-block;
    transition: all 0.3s;
    border: 2px solid ${colors.blue};
    border-radius: 15px;
    padding: 0 20px;
    height: 30px;
    font-size: 14px;
    line-height: 24px;
    font-weight: 600;
    color: ${colors.offWhite};
    text-decoration: none;

    &:hover {
      border: 2px solid ${colors.offWhite};
    }
  }
`;

const BannerImage = styled.div`
  position: absolute;
  top: -20px;
  left: -20px;
  background-size: cover;
  background-position: left;
  background-image: url('${props => props.src}');
  background-repeat: no-repeat;
  height: 640px;
  width: calc(100% + 40px);
  filter: blur(10px);
`;

const StyledHeader = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  margin-bottom: ${sp.max};
  height: 320px;

  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    content: '';
    background-color: rgba(43, 88, 153, 0.7); */
  }

  ${media.tablet`
    background-size: cover;
    background-position: left;
    background-image: url('${props => props.src}');
    background-repeat: no-repeat;
    height: 600px;
  `};

  h1 {
    ${mixins.heroText};
    margin: 0 auto;
    max-width: 600px;
    color: ${colors.white};
  }
`;

function Header(props) {
  const { heading, image, slug, categories } = props;
  const breadcrumbs = [
    {
      name: 'Home',
      link: '/',
    },
    {
      name: "Tap'd in",
      link: '/tapd-in',
    },
    {
      // name: heading,
      name: 'Article',
      link: `/tapd-in/${slug}`,
    },
  ];
  return (
    <StyledHeader>
      <BannerImage src={image.responsiveResolution.src} />
      <BannerContainer>
        <Breadcrumbs breadcrumbs={breadcrumbs} light />
        <h1>{heading}</h1>
        <BlogCategoryWrapper>
          {!!categories &&
            categories.map(category => (
              <BlogCategory key={category.id}>
                <a href={`/tapd-in/category/${category.slug}`}>
                  {category.title}
                </a>
              </BlogCategory>
            ))}
        </BlogCategoryWrapper>
      </BannerContainer>
    </StyledHeader>
  );
}

Header.propTypes = {
  heading: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  image: PropTypes.shape({}).isRequired,
  categories: PropTypes.arrayOf({}).isRequired,
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/BlogPage/components/Header/Header.jsx